import Vue from 'vue'
import firebase from "firebase"
import "./css/main.scss"
var config = {
    apiKey: "AIzaSyCfkTki6VRt_8iZSaVbx-YRM6GFOrs73xg",
    authDomain: "dnd-xr.firebaseapp.com",
    databaseURL: "https://dnd-xr.firebaseio.com",
    projectId: "dnd-xr",
    storageBucket: "dnd-xr.appspot.com",
    messagingSenderId: "985422516080"
}
firebase.initializeApp(config);
// Required for side-effects
import "firebase/firestore"

Vue.db = Vue.prototype.db = firebase.firestore()
Vue.rdb = Vue.prototype.rdb = firebase.database();
Vue.storage = Vue.prototype.storage = firebase.storage().ref();
import App from './App.vue'
import router from './router'
const requireComponent = require.context(
    './components', // The relative path of the components folder
    false, // Whether or not to look in subfolders
    /\w+\.(vue|js)$/ // The regular expression used to match base component filenames
)
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName) // Get component config
    const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    Vue.component(componentName, componentConfig.default || componentConfig) // Register component globally
})
Vue.config.productionTip = false

var app = new Vue({
    router,
    created() {
        this.db.collection("items").get().then(qS => {
            qS.forEach(doc => this.list.push({ id: doc.id, type: 'items' }));
        });
        this.db.collection("monsters").get().then(qS => {
            qS.forEach(doc => this.list.push({ id: doc.id, type: 'monsters' }));
        });
        this.db.collection("spells").get().then(qS => {
            qS.forEach(doc => this.list.push({ id: doc.id, type: 'spells' }));
        });
    },
    data: {
        list: []
    },
    render: h => h(App)
}).$mount('#app')